import React from 'react';
import PropTypes from 'prop-types';
import { Dialog as MuiDialog } from '@mui/material';

import DialogTitle from './DialogTitle';
import DialogContent from './DialogContent/Index';

function Dialog(props) {
  const {
    isOpen,
    onClose,
    children,
    title,
    isFormDialog,
    titleButton,
    contentStyle,
    leftTitleButton,
    ...rest
  } = props;

  return (
    <MuiDialog
      onClose={onClose}
      aria-labelledby="simple-dialog-title"
      open={isOpen}
      sx={{
        '.MuiPaper-root': {
          padding: '10px',
          maxWidth: rest.maxWidth ? undefined : 'fit-content',
          overflowY: 'auto !important',
          width: rest.fullWidth ? '100%' : undefined,
        },
        ...rest.sx,
        ...rest.style,
      }}
      {...rest}
    >
      {title && !leftTitleButton && (
        <DialogTitle
          titleButton={titleButton}
          data-id="simple-dialog-title"
          onClose={onClose}
        >
          {title}
        </DialogTitle>
      )}
      {isFormDialog ? children : <DialogContent>{children}</DialogContent>}
    </MuiDialog>
  );
}

Dialog.propTypes = {
  isOpen: PropTypes.bool.isRequired
};

export default Dialog;
